import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// Warm up the font hosts before React renders so the display typeface is
// available on the first paint (no visible font swap on the headline).
const preconnect = (href: string, crossOrigin?: boolean) => {
  if (document.head.querySelector(`link[rel="preconnect"][href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = href;
  if (crossOrigin) link.crossOrigin = "";
  document.head.appendChild(link);
};
preconnect("https://fonts.googleapis.com");
preconnect("https://fonts.gstatic.com", true);
// The mockup is fetched in CORS mode; the other images are not. Browsers keep
// separate connection pools for each, so warm up both.
preconnect("https://cdn.magicpatterns.com", true);
const cdnPlain = document.createElement("link");
cdnPlain.rel = "preconnect";
cdnPlain.href = "https://cdn.magicpatterns.com";
document.head.appendChild(cdnPlain);

// Start downloading the hero mockup immediately, in the same CORS mode the
// background-removal step uses, so it is reused instead of fetched twice.
const HERO_MOCKUP = "https://cdn.magicpatterns.com/uploads/6vdfHvDXyrLAT8GZhuV3HH/segundo_mockup.png";
if (!document.head.querySelector(`link[rel="preload"][href="${HERO_MOCKUP}"]`)) {
  const preload = document.createElement("link");
  preload.rel = "preload";
  preload.as = "image";
  preload.href = HERO_MOCKUP;
  preload.crossOrigin = "anonymous";
  preload.setAttribute("fetchpriority", "high");
  document.head.appendChild(preload);
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-409" data-mp="1eod04cz6vgmu" />);
}